import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { DRAWER_CONTENT_TYPES } from 'UI/pages/CommandCenter/OverallPerformance/OverallPerformance.constants';

import { FeedbackLog } from '../FeedbackLog';
import { FeedbackNoteForm } from '../FeedbackNoteForm';

const { form: STRINGS } = strings.commandCenter.feedbackNotes.drawer;

export const DrawerContent = ({
  drawerContent,
  employeeNumber,
  initialFeedbackNote,
  onNewItemClick = () => {},
  selectedNoteId = null
}) => {
  return drawerContent === DRAWER_CONTENT_TYPES.NotesForm ? (
    <>
      <Grid container>
        <Grid item>
          <Typography variant="h6">
            {selectedNoteId ? STRINGS.titles.editNote : STRINGS.titles.addNewNote}
          </Typography>
        </Grid>
      </Grid>
      <FeedbackNoteForm initialFeedbackNote={initialFeedbackNote} />
    </>
  ) : (
    <FeedbackLog employeeNumber={employeeNumber} onNewItemClick={onNewItemClick} />
  );
};
